import axios from "axios";
import { put, takeEvery } from "redux-saga/effects";
import { showError } from "../components/commonUtilities";
import {
    GET_LANGUAGE_OPTIONS,
    GetLanguageOptions,
    LanguageOptionsInterface,
    ReceivedLanguageOptions,
    SetCurrentLanguage
} from "../actions/MultiLingual/types";
import { receivedLanguageOptions, setCurrentLanguage } from "../actions/MultiLingual";
import { isPathPublicViewer } from "../Utilities/generalUtilities";
import { GeneratorYieldType } from "../interfaces/ActionReducer/GetMethod/GetResponse";
import { SelectValue } from "interfaces/Select/Value";

function* getLanguageOptions(
    action: GetLanguageOptions
): Generator<
    | Promise<ReceivedLanguageOptions["payload"]>
    | GeneratorYieldType<ReceivedLanguageOptions["payload"]>
    | GeneratorYieldType<SetCurrentLanguage["payload"]>,
    void,
    LanguageOptionsInterface
> {
    try {
        let json = yield axios
            .get("/api/language/", { params: action.payload.params })
            .then((response) => response.data);

        const searchParams = new URLSearchParams(window.location.search);
        const hotspotLanguage = searchParams.get("language");
        if (isPathPublicViewer()) {
            let currentLanguage: SelectValue = {
                label: "",
                value: ""
            };
            const langExists = (json as LanguageOptionsInterface).results.filter(
                (res: any) => res.display_name === hotspotLanguage
            );

            if (langExists.length) {
                currentLanguage = {
                    label: langExists[0].display_name,
                    value: langExists[0].name
                };
            }
            const defaultLang = (json as LanguageOptionsInterface).results.find(
                (language) => language.is_default
            );
            if (!hotspotLanguage && defaultLang) {
                currentLanguage = {
                    label: defaultLang.display_name,
                    value: defaultLang.name
                };
            }
            if (currentLanguage.value !== "") {
                yield put(
                    setCurrentLanguage({
                        currentLanguage: currentLanguage
                    })
                );
            }
        }

        yield put(receivedLanguageOptions({ languages: json }));
    } catch (e) {
        showError(e);
    }
}

export function* getLanguageOptionsSaga() {
    yield takeEvery(GET_LANGUAGE_OPTIONS, getLanguageOptions);
}
